module.exports = __webpack_public_path__ + "static/media/mouthPressLeft.a88a87cd.obj";